export default "__VITE_ASSET__9b1295ad__"